import React, { useEffect, useState } from "react";

// ASSETS
import PersonPlaceholder from "assets/img/PersonPlaceholder.png";

// STYLES
import {
  PersonnelSectionCarouselWrapper,
  PersonnelSectionContainer,
  PersonnelSectionSubtitleWrapper,
  PersonnelSectionTextWrapper,
  PersonnelSectionTitleWrapper,
} from "./PersonnelSectionStyled";

// LIBRARIES
import { useTranslation } from "react-i18next";

// MISC
import { TextType } from "components/Atoms/CustomText/CustomTextModel";
import { COLORS } from "constants/variables";
import { IProps } from "./PersonnelSectionModel";
import aboutService from "services/aboutService";
import { uploadBaseUrl } from "services/base";

// REDUX

// COMPONENTS
import CustomText from "components/Atoms/CustomText/CustomText";
import PersonnelWrapper from "components/PersonnelWrapper/PersonnelWrapper";
import Modal from "components/Modal/Modal";
import { ModalTypes } from "components/Modal/ModalModel";

const PersonnelSection = (props: IProps) => {
  // PROPERTIES

  // LIBRARY CONSTANTS
  const { t } = useTranslation();

  // STATE CONSTANTS
  const [team, setTeam] = useState<any>(null);
  const [modalState, setModalState] = useState({
    isVisible: false,
    type: "",
    item: null,
  });

  // API REQUESTS

  // LIFE CYCLE
  useEffect(() => {
    aboutService
      .getTeams()
      .then((response) => {
        // console.log("getTeams response", response);
        setTeam(response);
      })
      .catch((err) => {
        console.log("getTeams error", err);
      });
  }, []);

  const teamInfo = team?.data
    .map((teamMember: any) => {
      const tm = teamMember?.attributes.cv?.data[0];
      // console.log("teamMember", tm?.attributes?.attached_document.data.attributes.url)
      return {
        id: teamMember.id,
        fullName: teamMember.attributes.name,
        occupation: teamMember.attributes.role,
        order: teamMember.attributes.order,
        image: teamMember?.attributes?.photo?.data?.attributes?.url?.trim()
          ? `${uploadBaseUrl}${teamMember.attributes.photo?.data?.attributes?.url}`
          : PersonPlaceholder,
        bio: teamMember?.attributes?.bio,
        audience: teamMember?.attributes?.audience_schedule,
        CV: `${process.env.REACT_APP_UPLOAD_URL}${tm?.attributes?.attached_document.data.attributes.url}`,
      };
    })
    .sort((a, b) => {
      // Sort members with numbers first, null values last
      if (a.order === null && b.order === null) return 0; // Both are null, keep original order
      if (a.order === null) return 1; // Move null to the end
      if (b.order === null) return -1; // Move non-null to the front
      return a.order - b.order; // Sort by order number
    });

  // EVENT HANDLERS
  const handleClick = (member) => {
    setModalState({
      isVisible: true,
      type: ModalTypes.TEAM,
      item: member,
    });
  };

  return (
    <PersonnelSectionContainer>
      <PersonnelSectionTextWrapper>
        {/* <div style={{border:"solid #cf0000 1px",width:"200px",height:"150px"}}>*/}
        {/*</div>*/}
        <PersonnelSectionSubtitleWrapper>
          <CustomText
            text={t("view.about.aboutDSU.personnelSection.subtitle")}
            type={TextType.H2}
            color={COLORS.RaisinBlack}
          />
        </PersonnelSectionSubtitleWrapper>
      </PersonnelSectionTextWrapper>
      <PersonnelSectionCarouselWrapper>
        <PersonnelWrapper data={teamInfo} handleClick={handleClick} />
      </PersonnelSectionCarouselWrapper>
      <Modal
        isVisible={modalState.isVisible}
        type={modalState.type as ModalTypes}
        item={modalState.item}
        onClose={() =>
          setModalState({ isVisible: false, type: ModalTypes.NONE, item: null })
        }
      />
    </PersonnelSectionContainer>
  );
};

export default PersonnelSection;
